import { buildProps, definePropType } from '@lit-element/utils'
import { videoDefaultControlLayout } from './symbol'
import type { ExtractPropTypes, PropType } from 'vue'
import type {
  VideoControlLayout,
  VideoControlOption,
  VideoControlType,
  VideoPlaybackRate,
  VideoSegment,
  VideoShortcutOptions,
} from './symbol'
import type Video from './video.vue'

type ClassObjectType = Record<string, boolean>
type ClassType = string | ClassObjectType | ClassType[]

export const videoProps = buildProps({
  src: String,
  srcList: {
    type: Array as PropType<string[]>,
  },
  noControls: Boolean,
  videoAttrs: Object,
  time: {
    type: Number,
    default: 0,
  },
  volume: {
    type: Number,
    default: 1,
  },
  playbackRate: {
    type: Number,
    default: 1,
  },
  playbackRates: {
    type: Array as PropType<(number | VideoPlaybackRate)[]>,
    default: () => [0.5, 1, 1.25, 1.5, 2],
  },
  controlLayout: {
    type: Object as PropType<VideoControlLayout>,
    default: () => videoDefaultControlLayout,
  },
  poster: String,
  video: {
    type: Object as PropType<HTMLVideoElement>,
  },
  segments: {
    type: Array as PropType<(number | VideoSegment)[]>,
    default: () => [],
  },
  loading: Boolean,
  shortcuts: {
    type: Object as PropType<VideoShortcutOptions>,
    default: () => ({}),
  },
})

export type VideoProps = ExtractPropTypes<typeof videoProps>
export type VideoPropsInstance = InstanceType<typeof Video>

export const videoControlProps = buildProps({
  type: {
    type: String as PropType<VideoControlType>,
    default: 'button',
  },
  label: {
    type: String,
    default: '',
  },
  tipClass: {
    type: definePropType<ClassType>([String, Array, Object]),
    default: '',
  },
  disabled: Boolean,
  shortcut: String,
  focusable: Boolean,
  value: {
    type: [Number, String],
  },
  options: {
    type: Array as PropType<(string | VideoControlOption)[]>,
    default: () => [],
  },
})

export type VideoControlProps = ExtractPropTypes<typeof videoControlProps>
